module.exports = __webpack_public_path__ + "static/cliente_15-3b1494898e5eba6dc8fe1b0efcd354fa.png";